import { useMemo } from 'react';
import textAdditionalClassName from '../../../helpers/utils/TextAdditionalClassName';

interface Head7Props {
  children: React.ReactNode;
  className?: string;
  maxLines?: number;
  isClamp?: boolean;
  style?: React.CSSProperties;
  textBreak?: 'words' | 'characters' | 'none';
  overflow?: 'hidden' | 'visible';
}

const Head7 = ({
  children,
  maxLines = 2,
  className = '',
  isClamp = false,
  style = {},
  textBreak = 'words',
  overflow = 'hidden',
  ...props
}: Head7Props & React.ComponentProps<'p'>) => {
  const lineClampStyle: React.CSSProperties = isClamp
    ? {
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
      }
    : {};

  const additionalClassName = useMemo(
    () => textAdditionalClassName(textBreak, overflow),
    [textBreak, overflow]
  );
  return (
    <p
      style={{ ...lineClampStyle, ...style }}
      className={`text-[22px] font-semibold leading-[28px] text-black90 ${additionalClassName} ${className}`}
      {...props}
    >
      {children}
    </p>
  );
};

export default Head7;
